import script from "./OrderItem.vue?vue&type=script&setup=true&lang=js"
export * from "./OrderItem.vue?vue&type=script&setup=true&lang=js"

import "./style.scss?vue&type=style&index=0&id=f77584f2&scoped=true&lang=scss&external"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f77584f2"]])

export default __exports__